import BarGraph from "./class.BarGraph";
import ButtonPrompt from "./class.ButtonPrompt";
import ClearEverything from "./class.ClearEverything";
import ClearSticky from "./class.ClearSticky";
import ColumnConnection from "./class.ColumnConnection";
import DragDropCategories from "./class.DragDropCategories";
import DragDropMathjax from "./class.DragDropMathjax";
import DynamicGraph from "./class.DynamicGraph";
import GoTo from "./class.GoTo";
import HundredsChart from "./class.HundredsChart";
import MathjaxBlank from "./class.MathjaxBlank";
import Motor from "./class.Motor";
import MultiAnswerProblem from "./class.MultiAnswerProblem";
import RenderPrimitive from "./class.RenderPrimitive";
import SelectGraph from "./class.SelectGraph";
import SetVariable from "./class.SetVariable";
import ShortAnswerProblem from "./class.ShortAnswerProblem";
import SkipToChapter from "./class.SkipToChapter";
import VennDiagram from "./class.VennDiagram";

/**
 * An alphabetized list of all the enumerable Action classes.
 * If you make a new action, add it here!!!!!
 */
export default {
	BarGraph,
	ButtonPrompt,
	ClearEverything,
	ClearSticky,
	ColumnConnection,
	DragDropCategories,
	DragDropMathjax,
	DynamicGraph,
	GoTo,
	HundredsChart,
	MathjaxBlank,
	Motor,
	MultiAnswerProblem,
	RenderPrimitive,
	SelectGraph,
	SetVariable,
	ShortAnswerProblem,
	SkipToChapter,
	VennDiagram,
};
